<nav>
    <ul class="wider-links" *ngIf="!job" [ngClass]="{ active: active }">
        <li
            *ngIf="
                featureService.isAvailable('estimates_createviewjob') &&
                permissionService.isAvailable('estimates.maintain-estimates.create-job')
            ">
            <button type="button" class="btn-bx-secondary-stroked" (click)="createJob()" title="Create Job">Create Job</button>
        </li>
    </ul>

    <ul *ngIf="job" class="wider-links" [ngClass]="{ active: active }">
        <li *ngIf="permissionService.isAvailable('jobs.maintain-jobs.job-details') && featureService.isStateAvailable('jobs.view.details')">
            <a
                title="Job Details"
                [ngClass]="{ active: currentState.current.name === 'jobs.view.details' }"
                (click)="onChangeRoute($event, 'jobs.view.details', { id: job.ID_Job })"
                >Job Details</a
            >
        </li>
        <!-- Activity Feed - using the same permissions for jobs details-->
        <li *ngIf="permissionService.isAvailable('jobs.maintain-jobs.job-details') && featureService.isStateAvailable('jobs.view.details')">
            <a
                [title]="'jobs.activityFeed.title' | translate"
                [ngClass]="{ active: currentState.current.name === 'jobs.view.activityfeed' }"
                (click)="onChangeRoute($event, 'jobs.view.activityfeed', { id: job.ID_Job })"
                >{{ 'jobs.activityFeed.title' | translate }}</a
            >
        </li>
        @if (
            permissionService.isAvailable('jobs.maintain-schedules.schedule-menu') && featureService.isStateAvailable('jobs.view.schedule')
        ) {
            <li>
                <a
                    title="Schedule"
                    [ngClass]="{ active: currentState.current.name === 'jobs.view.schedule' }"
                    (click)="onChangeRoute($event, 'jobs.view.schedule', { id: job.ID_Job })">
                    Schedule
                </a>
            </li>
        }

        <li
            *ngIf="
                permissionService.isAvailable('jobs.maintain-purchase-orders.purchase-orders-menu') &&
                featureService.isStateAvailable('jobs.view.costings')
            ">
            <a
                title="Purchase Orders"
                [ngClass]="{ active: currentState.current.name == 'jobs.view.costings.orders' && currentStateParams.type == 'purchase' }"
                (click)="
                    onChangeRoute($event, 'jobs.view.costings.orders', {
                        type: 'purchase',
                        id: job.ID_Job,
                        subpanel: currentStateParams.subpanel,
                        submenu: currentStateParams.submenu,
                        open: currentStateParams.open,
                        status: currentStateParams.status,
                        options: currentStateParams.options,
                    })
                "
                >Purchase Orders</a
            >
        </li>

        <li
            *ngIf="
                permissionService.isAvailable('jobs.maintain-work-orders.work-orders-menu') &&
                featureService.isStateAvailable('jobs.view.costings')
            ">
            <a
                title="Work Orders"
                [ngClass]="{ active: currentState.current.name == 'jobs.view.costings.orders' && currentStateParams.type == 'work' }"
                (click)="
                    onChangeRoute($event, 'jobs.view.costings.orders', {
                        type: 'work',
                        id: job.ID_Job,
                        subpanel: currentStateParams.subpanel,
                        submenu: currentStateParams.submenu,
                        open: currentStateParams.open,
                        status: currentStateParams.status,
                        options: currentStateParams.options,
                    })
                "
                >Work Orders</a
            >
        </li>

        <li
            *ngIf="
                permissionService.isAvailable('jobs.maintain-job-costings.actual-items-menu') &&
                featureService.isStateAvailable('jobs.view.costings')
            ">
            <a
                title="Actuals Costings"
                [ngClass]="{ active: currentState.current.name == 'jobs.view.costings.actuals' }"
                (click)="onChangeRoute($event, 'jobs.view.costings.actuals', { id: job.ID_Job })"
                >Actuals Costings</a
            >
        </li>

        <li
            *ngIf="
                permissionService.isAvailable('request-for-quote.rfq-access.rfq-menu') && featureService.isStateAvailable('quoterequests')
            ">
            <a
                title="Request for Quotes"
                [ngClass]="{ active: currentState.current.name == 'jobs.view.quoterequests' }"
                (click)="onChangeRoute($event, 'jobs.view.quoterequests', { id: job.ID_Job })"
                >Request for Quotes</a
            >
        </li>

        <li
            *ngIf="
                permissionService.isAvailable('jobs.maintain-variations.variations-menu') &&
                featureService.isStateAvailable('jobs.view.variations')
            ">
            <a
                title="{{ 'general.variations' | translate }}"
                [ngClass]="{ active: currentState.current.name == 'jobs.view.variations' }"
                (click)="onChangeRoute($event, 'jobs.view.variations', { id: job.ID_Job })"
                >{{ 'general.variations' | translate }}</a
            >
        </li>

        <li
            *ngIf="
                permissionService.isAvailable('jobs.maintain-invoices.invoicing-menu') &&
                featureService.isStateAvailable('jobs.view.invoices') &&
                job.InvoiceMethod === 0
            ">
            <a
                title="Outgoing Invoices"
                [ngClass]="{ active: currentState.current.name == 'jobs.view.invoices' }"
                (click)="onChangeRoute($event, 'jobs.view.invoices', { id: job.ID_Job })"
                >Outgoing Invoices</a
            >
        </li>

        <li
            *ngIf="
                permissionService.isAvailable('jobs.maintain-invoices.invoicing-menu') &&
                featureService.isStateAvailable('jobs.view.invoices-cost-plus') &&
                job.InvoiceMethod === 1
            ">
            <a
                title="Outgoing Invoices"
                [ngClass]="{ active: currentState.current.name == 'jobs.view.invoices' }"
                (click)="onChangeRoute($event, 'jobs.view.invoices-cost-plus', { id: job.ID_Job })"
                >Outgoing Invoices</a
            >
        </li>

        <li
            *ngIf="
                permissionService.isAvailable('jobs.maintain-invoices.invoicing-menu') &&
                featureService.isStateAvailable('jobs.view.invoices-comp-perc') &&
                job.InvoiceMethod === 2
            ">
            <a
                title="Outgoing Invoices"
                [ngClass]="{ active: currentState.current.name == 'jobs.view.invoices' }"
                (click)="onChangeRoute($event, 'jobs.view.invoices-comp-perc', { id: job.ID_Job })"
                >Outgoing Invoices</a
            >
        </li>
    </ul>
</nav>
